import MessagesList from './messages-list';

export default MessagesList;
